<div *ngIf="loading" [ngClass]="isAuth ? 'auth-overlay' : 'overlay'">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
